<template>
  <div class="main">
    <van-image class="banner" fit="cover" src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/cooperation/9.jpg" />
    <div class="tab">
      <img :src="item" alt="" v-for="item of list" :key="item" />
    </div>
    <div class="company">
      <div class="list">
        <div class="left">
          <div class="title">
            <!-- <div class="circle"></div> -->
            <div>北京公司</div>
          </div>
          <!-- <div class="line"></div> -->
        </div>
        <div class="right">
          <!-- <span class="name">王先生</span> -->
          <div>
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/cooperation/1.png" alt="" />
            <span>010-87798847</span>
          </div>
          <div>
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/cooperation/2.png" alt="" />
            <span>info@growlib.com</span>
          </div>
          <div>
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/cooperation/3.png" alt="" />
            <span>北京市朝阳区酒仙桥路4号宏源大厦1308室</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="supplement">以上各分公司各个业务的联系人、联系方式、地址信息正在收集汇聚中</div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/cooperation/4.png',
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/cooperation/5.png',
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/cooperation/6.png',
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/cooperation/7.png',
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/cooperation/8.png'
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  min-height: (100vh - 20px);
  .banner {
    width: 100%;
    min-height: 100px;
    height: 500px;
  }
  .tab {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: -100px;
    position: relative;
    z-index: 1;
    img {
      width: 200px;
      height: 278px;
      // border: 12px solid #fff;
    }
  }
  .company {
    width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    padding-bottom: 100px;
    .list {
      display: flex;
      margin: 0 auto;
      width: 820px;
      .left {
        width: 300px;
        margin-top: 30px;
        display: flex;
        align-items: center;
        font-weight: 500;
        .title {
          display: flex;
          align-items: center;
          font-size: 36px;
          color: #727272;
          line-height: 1;
          .circle {
            width: 17px;
            height: 17px;
            border-radius: 50%;
            background: #f27529;
            margin-right: 11px;
          }
        }
        .line {
          background-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0),
            rgba(0, 0, 0, 0.6),
            rgba(255, 255, 255, 0),
          );
          width: 1px;
          height: 231px;
          margin-left: 7px;
        }
      }
      .right {
        .name {
          font-size: 30px;
          color: #727272;
          line-height: 36px;
        }
        > div {
          display: flex;
          align-items: center;
          margin-top: 30px;
          img{
            width: 29px;
            height: 34px;
            margin-right: 12px;
          }
          span{
            font-size: 24px;
            color: #727272;
            line-height: 29px;
          }
        }
      }
    }
  }
  .supplement{
    font-size: 18px;
    color: #9FA1B4;
    line-height: 24px;
    text-align: center;
    padding: 68px 0 50px 0;
  }
}
</style>
